import axios from 'axios';

function getPageData() {
    const widgetId = (window.location.pathname || '').split('/').pop();
    return axios.get(`/api-site/widget/info/${widgetId}`);
}

export default function getWidgetData() {
    return getPageData().then(({ data: ret }) => {
        const rawGlobalData = {
            ...JSON.parse(ret.globalData.data),
            siteId: ret.globalData.siteId,
            FEATURE_AREA_VERSION: ret.globalData.FEATURE_AREA_VERSION || false,
            domainName: ret.domainName,
            searchCenter: ret.searchCenter,
            widget: true,
            mlsOrgs: ret.mlsOrgs || []
        };

        const rawPageData = {
            moduleData: [{
                name: ret.type,
                data: JSON.parse(ret.data)
            }]
        };
        const pageResource = ret.pageResource;

        return {
            rawGlobalData,
            rawPageData,
            pageResource
        }

        // Track.prepare();
        // sitePageInit({
        //     pageData: {
        //         modules: [{ data: moduleData, name: ret.type }]
        //     },
        //     globalData: {
        //         ...JSON.parse(globalData.data),
        //         siteId: globalData.siteId,
        //         domainName: ret.domainName,
        //         searchCenter: ret.searchCenter,
        //         widget: true
        //     }
        // });
    })
}